export default __webpack_public_path__ + "static/media/database.686baaa0.svg";